import { Search } from 'lucide-react'

export default function FilterBar({ filters, setFilters }) {
  return (
  <div className="card p-6 mb-8 bg-white dark:bg-gray-900 dark:text-white">
      <div className="max-w-md">
        <label className="block text-sm font-medium text-nitrr-text dark:text-white mb-2">
          Search Logos
        </label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-nitrr-text-muted dark:text-gray-400" size={18} />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            placeholder="Search logos by name..."
            className="input pl-10 w-full dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-400"
          />
        </div>
      </div>
    </div>
  )
}
